export const environment = {
    production: false,
    urlApi: 'https://api.promomania.it/api/',
    urlApiStatic: 'https://static.promomania.it/',
    firebaseConfig: {
        apiKey: 'AIzaSyCNIwQ0R6GDxJV74l4AVC2tf9J5obNBlw0',
        authDomain: 'gosumania-app.firebaseapp.com',
        projectId: 'gosumania-app',
        storageBucket: 'gosumania-app.appspot.com',
        messagingSenderId: '606740515057',
        appId: '1:606740515057:web:07b781f826d5beba020150',
        measurementId: 'G-7WM7FK9W4V',
        webClientId: '606740515057-qlb4c7vk0seocre906n2eh9sfklgqtid.apps.googleusercontent.com',
        iosClientId: '606740515057-eug0qagu3dblvtkpu9gquaeq1e6icuso.apps.googleusercontent.com'
    },
    storageVersion: '8',
    allowedDomains: ['api.promomania.it'],
    disallowedRoutes: [],

    /***** END POINT API *****/

    /*** ActivatedNotification ***/
    ACTIVATED_NOTIFICATION_CHECK: 'activated-notification/check',
    ACTIVATED_NOTIFICATION_UPDATE: 'activated-notification/update',

    /*** Communication ***/
    COMMUNICATION_GET_ALL: 'communication/get-all',
    COMMUNICATION_GET_ALL_FIRST_ACCESS:  'communication/get-all',
    COMMUNICATION_CREATE_OR_UPDATE: 'communication/create-or-update',
    COMMUNICATION_GET_BY_ID: 'communication/get-by-id',
    COMMUNICATION_DELETE: 'communication/delete',

    COMMUNICATION_LIKE_CREATE: 'communication-like/create',
    COMMUNICATION_LIKE_DELETE: 'communication-like/delete',

    COMMUNICATION_COMMENT_GET_ALL: 'communication-comment/get-all',
    COMMUNICATION_COMMENT_CREATE_OR_UPDATE: 'communication-comment/create-or-update',
    COMMUNICATION_COMMENT_REPORT: 'communication-comment/report',
    COMMUNICATION_COMMENT_DELETE: 'communication-comment/delete',
    COMMUNICATION_COMMENT_DELETE_FROM_ADMIN: 'communication-comment/delete-from-admin',

    COMMUNICATION_COMMENT_LIKE_CREATE: 'communication-comment-like/create',
    COMMUNICATION_COMMENT_LIKE_DELETE: 'communication-comment-like/delete',

    /*** Newspaper ***/
    NEWSPAPER_GET_ALL: 'newspaper/get-all',
    NEWSPAPER_GET_ALL_FIRST_ACCESS: 'newspaper/get-all',
    NEWSPAPER_CREATE_OR_UPDATE: 'newspaper/create-or-update',
    NEWSPAPER_GET_BY_ID: 'newspaper/get-by-id',
    NEWSPAPER_DELETE: 'newspaper/delete',


    NEWSPAPER_LIKE_CREATE: 'newspaper-like/create',
    NEWSPAPER_LIKE_DELETE: 'newspaper-like/delete',

    NEWSPAPER_COMMENT_GET_ALL: 'newspaper-comment/get-all',
    NEWSPAPER_COMMENT_CREATE_OR_UPDATE: 'newspaper-comment/create-or-update',
    NEWSPAPER_COMMENT_REPORT: 'newspaper-comment/report',
    NEWSPAPER_COMMENT_DELETE: 'newspaper-comment/delete',
    NEWSPAPER_COMMENT_DELETE_FROM_ADMIN: 'newspaper-comment/delete-from-admin',

    NEWSPAPER_COMMENT_LIKE_CREATE: 'newspaper-comment-like/create',
    NEWSPAPER_COMMENT_LIKE_DELETE: 'newspaper-comment-like/delete',

    /*** Tutorial ***/
    TUTORIAL_GET_ALL: 'tutorial/get-all',
    TUTORIAL_GET_ALL_FIRST_ACCESS: 'tutorial/get-all',
    TUTORIAL_CREATE_OR_UPDATE: 'tutorial/create-or-update',
    TUTORIAL_GET_BY_ID: 'tutorial/get-by-id',
    TUTORIAL_DELETE: 'tutorial/delete',

    TUTORIAL_LIKE_CREATE: 'tutorial-like/create',
    TUTORIAL_LIKE_DELETE: 'tutorial-like/delete',

    TUTORIAL_COMMENT_GET_ALL: 'tutorial-comment/get-all',
    TUTORIAL_COMMENT_CREATE_OR_UPDATE: 'tutorial-comment/create-or-update',
    TUTORIAL_COMMENT_REPORT: 'tutorial-comment/report',
    TUTORIAL_COMMENT_DELETE: 'tutorial-comment/delete',
    TUTORIAL_COMMENT_DELETE_FROM_ADMIN: 'tutorial-comment/delete-from-admin',

    TUTORIAL_COMMENT_LIKE_CREATE: 'tutorial-comment-like/create',
    TUTORIAL_COMMENT_LIKE_DELETE: 'tutorial-comment-like/delete',

    /*** ErrorLog ***/
    ERROR_LOG_GET_ALL: 'error-log/get-all',
    ERROR_LOG_CREATE: 'error-log/create',
    ERROR_LOG_GET_BY_ID: 'error-log/get-by-id',
    ERROR_LOG_DELETE: 'error-log/delete',

    /*** ImageInfoWP ***/
    IMAGE_INFO_WP_GET_ALL: 'image-info-wp/get-all',
    IMAGE_INFO_WP_CREATE_OR_UPDATE: 'image-info-wp/create-or-update',
    IMAGE_INFO_WP_GET_BY_ID: 'image-info-wp/get-by-id',
    IMAGE_INFO_WP_DELETE: 'image-info-wp/delete',

    /*** AffiliateTag ***/
    AFFILIATE_TAG_GET_ALL: 'affiliate-tag/get-all',
    AFFILIATE_TAG_GET_ALL_FIRST_ACCESS: 'affiliate-tag/get-all',
    AFFILIATE_TAG_CREATE_OR_UPDATE: 'affiliate-tag/create-or-update',
    AFFILIATE_TAG_GET_BY_ID: 'affiliate-tag/get-by-id',
    AFFILIATE_TAG_DELETE: 'affiliate-tag/delete',

    /*** Keepa ***/
    KEEPA_GET_LIGHTNING_DEAL: 'keepa/get-lightning-Deal/',
    KEEPA_SEARCH_PRODUCT: 'keepa/search-product',
    KEEPA_GET_PRODUCT_INFO: 'keepa/get-product-info',
    KEEPA_GET_TRACKING_LIST: 'keepa/get-tracking-list',
    KEEPA_ADD_TRACKING_PRODUCT: 'keepa/add-tracking-product',
    KEEPA_REMOVE_TRACKING_PRODUCT: 'keepa/remove-tracking-product',

    KEEPA_TRACKED_PRODUCT_GET_ALL: 'keepa-tracked-product/get-all',
    KEEPA_TRACKED_PRODUCT_CREATE_OR_UPDATE: 'keepa-tracked-product/create-or-update',
    KEEPA_TRACKED_PRODUCT_TOOL_USER_CREATE_OR_UPDATE: 'keepa-tracked-product/tool-user/create-or-update',
    KEEPA_TRACKED_PRODUCT_LOGIC_DELETE: 'keepa-tracked-product/logic-delete',
    KEEPA_TRACKED_PRODUCT_DELETE: 'keepa-tracked-product/delete',

    /*** NotificationToken  ***/
    NOTIFICATION_TOKEN_GET_ALL: 'notification-token/get-all',
    NOTIFICATION_TOKEN_CREATE_OR_UPDATE: 'notification-token/create-or-update',

    /*** UserFavoriteProductList ***/
    USER_FAVORITE_PRODUCT_LIST_GET_ALL: 'user-favorite-product-list/get-all/',
    USER_FAVORITE_PRODUCT_LIST_GET_LIST_BY_TOKEN: 'user-favorite-product-list/get-list-by-token',
    USER_FAVORITE_PRODUCT_LIST_GET_LIST_BY_USER_ID: 'user-favorite-product-list/get-list-by-user-id',
    USER_FAVORITE_PRODUCT_LIST_CREATE_OR_UPDATE: 'user-favorite-product-list/create-or-update',
    USER_FAVORITE_PRODUCT_LIST_GET_BY_ID: 'user-favorite-product-list/get-by-id',
    USER_FAVORITE_PRODUCT_LIST_DELETE: 'user-favorite-product-list/delete',
    USER_FAVORITE_PRODUCT_LIST_DELETE_BY_USER_TOKEN: 'user-favorite-product-list/delete-by-user-token',

    /*** ToolUser ***/
    TOOL_USER_AUTHENTICATE: 'tool-user/authenticate/',
    TOOL_USER_UPDATE: 'tool-user/update',
    TOOL_USER_ADMIN_UPDATE: 'tool-user/admin-update',
    TOOL_USER_RESEND_VERIFICATION_EMAIL: 'tool-user/resend-verification-email',
    TOOL_USER_RESET_PASSWORD: 'tool-user/reset-password',
    TOOL_USER_CHANGE_PASSWORD: 'tool-user/change-password',
    TOOL_USER_INFO: 'tool-user/info',

    /*** Deal ***/
    DEAL_GET_LIST_APP: 'deal/get-list-app',
    DEAL_GET_LIST_APP_FIRST_ACCESS: 'deal/get-list-app',
    DEAL_GET_LIST_TELEGRAM: 'deal/get-list-telegram',
    DEAL_CREATE_OR_UPDATE: 'deal/create-or-update',
    DEAL_GET_BY_ID: 'deal/get-by-id',
    DEAL_FINISHED: 'deal/finished',
    DEAL_DELETE: 'deal/delete',
    DEAL_REPORT_FINISHED: 'deal/report-finished',
    DEAL_REPORT_ERROR: 'deal/report-error',

    DEAL_LIKE_CREATE: 'deal-like/create',
    DEAL_LIKE_DELETE: 'deal-like/delete',


    DEAL_COMMENT_GET_ALL: 'deal-comment/get-all',
    DEAL_COMMENT_GET_ALL_NO_LOADING: 'deal-comment/get-all',
    DEAL_COMMENT_CREATE_OR_UPDATE: 'deal-comment/create-or-update',
    DEAL_COMMENT_REPORT: 'deal-comment/report',
    DEAL_COMMENT_DELETE: 'deal-comment/delete',
    DEAL_COMMENT_DELETE_FROM_ADMIN: 'deal-comment/delete-from-admin',

    DEAL_COMMENT_LIKE_CREATE: 'deal-comment-like/create',
    DEAL_COMMENT_LIKE_DELETE: 'deal-comment-like/delete',


    /*** Notification ***/
    NOTIFICATION_GET_ALL: 'notification/get-all',
    NOTIFICATION_GET_ALL_FIRST_ACCESS: 'notification/get-all',
    NOTIFICATION_CREATE_OR_UPDATE: 'notification/create-or-update',
    NOTIFICATION_SEND_TO_TOPIC: 'notification/send-to-topic',
    NOTIFICATION_SEND_TO_FAVORITE: 'notification/send-to-favorite',

    /*** InEvidence ***/
    IN_EVIDENCE_GET_ALL: 'in-evidence/get-all',
    IN_EVIDENCE_GET_ALL_FIRST_ACCESS: 'in-evidence/get-all',
    IN_EVIDENCE_CREATE_OR_UPDATE: 'in-evidence/create-or-update',
    IN_EVIDENCE_GET_BY_ID: 'in-evidence/get-by-id',
    IN_EVIDENCE_UPDATE_ALL: 'in-evidence/update-all',
    IN_EVIDENCE_DELETE: 'in-evidence/delete',

    /*** User ***/
    USER_GET_ALL: 'user/get-all',
    USER_CREATE_OR_UPDATE: 'user/create-or-update',
    USER_GET_BY_ID: 'user/get-by-id',
    USER_UPDATE: 'user/update',
    USER_UPDATE_EMAIL_VERFIED: 'user/update-email-verified',
    USER_DISABLED_USER: 'user/disabled-user',
    USER_ENABLED_USER: 'user/enabled-user',
    USER_AUTHENTICATE: 'user/authenticate',
    USER_AUTHENTICATE_GOOGLE: 'user/google-authenticate',
    USER_RESET_PASSWORD: 'user/reset-password',
    USER_CHANGE_PASSWORD: 'user/change-password',
    USER_UPDATE_PROFILE_IMAGE: 'user/update-profile-image',
    USER_UPDATE_DISPLAY_NAME: 'user/update-display-name',
    USER_DELETE: 'user/delete',
    UTILITY_GET_WORDS_BLACKLIST: 'utility/get-words-blacklist',
    USER_GET_USERNAME_LIST: 'user/get-username-list',

    USER_LIKE_GET_ALL: 'user-like/get-all',

    /*** NewDealNotification ***/
    NEW_DEAL_NOTIFICATION_GET_ALL: 'new-deal-notification/get-all',
    NEW_DEAL_NOTIFICATION_CREATE_SEND: 'new-deal-notification/create-send',
    NEW_DEAL_NOTIFICATION_DESTROY: 'new-deal-notification/destroy',

    AMAZON_GET_PRODUCT_INFO: 'amazon/get-product-info',

    /*** Utility ***/
    UTILITY_STRETCH_LINK: 'utility/stretch-link',

    /*** Maintenance ***/
    MAINTENANCE_GET: 'maintenance/get',

    /*** UpdateApp ***/
    UPDATE_APP_GET: 'update-app/get',

    /*** AppTutorial ***/
    APP_TUTORIAL_GET_ALL: 'app-tutorial/get-all',

    /*** TermsAndConditions ***/
    TERMS_AND_CONDITIONS_GET_LAST: 'terms-and-conditions/get-last',

    /*** Theme App ***/
    APP_THEME_GET: 'app-theme/get'
};
